<template>
  <div class="">
        <Tabs v-model="tabsSelect" :animated="false" type="card">
            <TabPane v-for="tab in activeLabList" :key="tab" :label="modules[tab]" :name="tab">
                <fp-pressure v-if="tabsSelect == tab && tab =='yl'" :id="partId"></fp-pressure>
                <fp-flow v-if="tabsSelect == tab && tab =='ll'" :id="partId"></fp-flow>
                <fp-water v-if="tabsSelect == tab && tab =='sw'" :id="partId"></fp-water>
                <fp-state v-if="tabsSelect == tab && tab =='zt'" :id="partId"></fp-state>
                <wit-control v-if="tabsSelect == tab && tab =='kz'" :id="partId"></wit-control>
            </TabPane>
        </Tabs>
  </div>
</template>
<script>
import fpPressure from './fp-pressure'
import fpFlow from './fp-flow'
import fpState from './fp-state'
import fpWater from './fp-water'
import witEcharts from './fan-echarts'
import witControl from '../wit-electric-monitor/wit-control'
// 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
export default {
  name:"",    
  data: () => ({
        loginData: {},
        choice: {
            id: ''
        },
        id: '',
        data: [],
        modules:{
            'yl':'压力',
            'll':'流量',
            'sw':'水位',
            'kz':'控制',
        },
        treeSelectStatus: false,
        tabsSelect: '',
        tabList: [],
        orgId: ''
  }),
  props: [
      'partId'
  ],
  components: {
    fpPressure,
    fpFlow,
    fpState,
    fpWater,
    witEcharts,
    witControl
  },
  created() {

  },
  mounted() {
    this.getCardInfoData();
    this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
  },
  computed: {
    activeLabList(){
        return this.tabList.filter(item => this.modules[item]);
    }
  },
  methods: {
      //获取数据开始
    getPwdHash(pwd, data) {
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
    getCardInfoData(){
        return new Promise((resolve, reject) => {
            let url = `/mcbw/network_monitor/pointTypes/${this.partId}`;
            let _this = this;
            var data = {
                type: 'get',
                url: url,
                obj: {
                    orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                    pointId: this.pointId,
                    pointValue: this.pointValue,
                    passWord: this.userPassword,
                }
            };
            _this.$Axios(data).then((res) => {
                if (res) {
                    if (res.data.data && res.data.data.length) {
                        res.data.data.forEach((item,index)=>{
                            if(item == "gl" && (this.orgId == '147175' || this.orgId == '146139')){
                                res.data.data.splice(index, 1);
                            }
                        })
                        this.tabList = res.data.data;
                        this.tabsSelect = res.data.data[0];
                    }
                }
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    },
  }
}
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/fp/fire-pump.vue